import React, { Component } from "react";
import { Typography } from "@material-ui/core";
import { AppContext } from "../contexts";

class NotFoundPage extends Component {
  state = {
    seconds: 5,
  };

  componentDidMount() {
    window.setInterval(() => {
      this.setState({ seconds: this.state.seconds - 1 });

      if (this.state.seconds == 0) {
        window.location.href = "/";
      }
    }, 1000);
  }

  render() {
    return (
      <AppContext.Consumer>
        {(settings) => (
          <div className="centered-container">
            <img
              style={{ margin: "30px auto", display: "block" }}
              id="logo"
              alt=""
              src={settings.logo}
            />
            <Typography align="center">
              Deze pagina bestaat (niet) meer. U wordt binnen{" "}
              <b>{this.state.seconds}</b> seconden naar de startpagina herleid.
            </Typography>
          </div>
        )}
      </AppContext.Consumer>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js